import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
  FormField,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import React from 'react';
import { FieldPathByValue, FieldValues } from 'react-hook-form';

import { FieldDecorators, FieldProps } from './shared';

export function InputField<
  T extends FieldValues,
  P extends FieldPathByValue<T, string> | FieldPathByValue<T, number>,
>({
  control,
  name,
  rules,
  label,
  description,
  startDecorator,
  endDecorator,
  className,
  placeholder,
  ...props
}: FieldProps<T, P> &
  React.ComponentPropsWithoutRef<typeof Input> &
  FieldDecorators) {
  const startDecoratorElement = startDecorator && (
    <span className="absolute top-1/2 left-0.5 -translate-y-1/2">
      {startDecorator}
    </span>
  );

  const endDecoratorElement = endDecorator && (
    <span className="absolute top-1/2 right-0.5 -translate-y-1/2">
      {endDecorator}
    </span>
  );

  return (
    <FormField
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <FormItem className="grow">
          {label && <FormLabel>{label}</FormLabel>}
          <div className="relative">
            {startDecoratorElement}
            <FormControl>
              <Input
                className={cn(
                  { 'pl-12': startDecorator, 'pr-12': endDecorator },
                  className
                )}
                placeholder={placeholder ?? label}
                {...props}
                {...field}
              />
            </FormControl>
            {endDecoratorElement}
          </div>
          {description && (
            <FormDescription>{description(field.value)}</FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
